export const ADMIN_PATH = "/bg-admin-portal";
export const ADMIN_LOGIN_PATH = `${ADMIN_PATH}/login`;
